import type { Paquete } from "@/interfaces/paquetes.interface";
import AccionesPaqueteCell from "@/components/AccionesTablas/Paquete.acciones";
import type { ColumnDef } from "@tanstack/react-table";

export function getPaqueteColumns(
  queryKey: ReadonlyArray<unknown>,
): ColumnDef<Paquete>[] {
  return [
    {
      header: "ID",
      accessorKey: "id",
    },
    {
      header: "Programa",
      accessorKey: "programa.nombre",
    },
    {
      header: "Cupo máximo",
      accessorKey: "cantidadLearners",
    },
    // {
    //   header: "Inicio",
    //   accessorKey: "fechaInicio",
    //   cell: ({ getValue }) => {
    //     const value = getValue() as string | null;
    //     return value ? formatearFechaISOaDDMMYYYY(value) : "";
    //   },
    // },
    // {
    //   header: "Vencimiento",
    //   accessorKey: "fechaVencimiento",
    //   cell: ({ getValue }) => {
    //     const value = getValue() as string | null;
    //     return value ? formatearFechaISOaDDMMYYYY(value) : "";
    //   },
    // },
    {
      id: "acciones",
      header: "Acciones",
      cell: ({ row }) => (
        <AccionesPaqueteCell paquete={row.original} queryKey={queryKey} />
      ),
    },
  ];
}
